module.exports = __webpack_public_path__ + "static/img/Taj-Hotton.78fc089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taj-Hotton.jpg
// module id = 2SWR
// module chunks = 0